import { render, staticRenderFns } from "./deleteSolidityContract.vue?vue&type=template&id=2cb07b2c&scoped=true&"
import script from "./deleteSolidityContract.vue?vue&type=script&lang=js&"
export * from "./deleteSolidityContract.vue?vue&type=script&lang=js&"
import style0 from "./deleteSolidityContract.vue?vue&type=style&index=0&id=2cb07b2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb07b2c",
  null
  
)

export default component.exports